<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-bottom has-background-light is-minH50p is-marginless">
      <div class="column is-padding-left">
        <span class="is-size-6">{{ items.length }} lot<span v-if="items.length > 1">s</span> en favoris</span>
      </div>
    </div>
    <table-controls-vue
      :has-sticky="true"
      v-if="!loading && items.length">
      <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium has-actionsontd">
        <thead class="has-cells-vcentered">
          <tr class="is-size-6">
            <th
              class="is-paddingless has-text-centered"
              style="z-index:2;">
              <columns-toggles
                :entries="columnsList"
                :source="columns"
                @update="updateColumns"></columns-toggles>
            </th>
            <th>
              <span>Lot</span>
            </th>
            <th v-if="showColumn('program__name')">
              <span>Programme</span>
            </th>
            <th v-if="showColumn('promoteur__name') && isAdmin && isDistributeur">
              <span>Promoteur</span>
            </th>
            <th v-if="showColumn('address__zip_code')">
              <span>Code Postal</span>
            </th>
            <th v-if="showColumn('address__city')">
              <span>Ville</span>
            </th>
            <th v-if="showColumn('nature')">
              <span>Nature</span>
            </th>
            <th v-if="showColumn('lot_type')">
              <span>Type</span>
            </th>
            <th v-if="showColumn('lot_subtype')">
              <span>Caractéristiques</span>
            </th>
            <th v-if="showColumn('surface')">
              <span>Surface</span>
            </th>
            <th v-if="showColumn('tranche')">
              <span>Tranche</span>
            </th>
            <th v-if="showColumn('building')">
              <span>Bâtiment</span>
            </th>
            <th v-if="showColumn('floor')">
              <span>Étage</span>
            </th>
            <th v-if="showColumn('exposures')">
              <span>Orientation</span>
            </th>
            <th v-if="showColumn('parking')">
              <span>Parking</span>
            </th>
            <th
              v-if="showColumn('sale_price_ht')"
              class="is-nowrap">
              <span>Prix de Vente HT</span>
            </th>
            <th class="is-nowrap">
              <span>Prix de Vente</span>
            </th>
            <th
              v-if="showColumn('rent')"
              class="is-nowrap">
              <span>Loyer HC</span>
            </th>
            <th v-if="showColumn('tax_dispositifs')">
              <span>Dispositif(s)</span>
            </th>
            <th v-if="showColumn('profitability')">
              <span>Rentabilité</span>
            </th>
            <th v-if="showColumn('capped_profitability')">
              <span>Rentabilité plafonnée</span>
            </th>
            <th v-if="showColumn('date_livraison')">
              <span>Livraison</span>
            </th>
            <th v-if="showColumn('date_actabilite')">
              <span>Actabilité</span>
            </th>
            <th v-if="isAdmin && showColumn('created_on')">
              <span>Créé le</span>
            </th>
            <th class="has-text-centered"></th>
          </tr>
        </thead>
        <lot-row
          v-for="(l, i) in items"
          :id="'e' + l.pk"
          :key="l.pk"
          :source-lot="l"
          :index="i"
          :source-lots="items"
          :columns-lot-row="columns"
          :current-page-lot-row="currentPageLots"
          :total-lot-row="items.length"
          :from-wish-list="true"
          :is-program-view="false"
          @deleteFromWishlist="deleteFromWishlist"></lot-row>
      </table>
    </table-controls-vue>
    <div v-show="!loading && !items.length">
      <div class="is-padding">
        <h2 class="title is-3 has-text-weight-bold">
          Aucun favoris disponible
        </h2>
      </div>
    </div>
    <pagination
      :loading="loading"
      :current-page="currentPage"
      :total-page="totalPage"
      @changePage="loadItems($event)">
    </pagination>
  </div>
</template>

<script>
import { ColumnConf, DefaultValues, Filter, GenericList, Sort } from '@/mixins'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'LotWishlistList',
  components: {
    LotRow: () => import('../stock/LotRow')
  },
  mixins: [GenericList, Sort, DefaultValues, Filter, ColumnConf],
  props: {
    propsTab: String
  },
  data () {
    return {
      currentPageLots: 0,
      lightList: true,
      loadDocuments: this.loadItems,
      service: 'WISHLIST',
      columnsConfResource: 'lots'
    }
  },
  computed: {
    ...mapGetters(['isPromoteur', 'isAdmin', 'isDistributeur']),
    today () {
      return moment()
    },
    columnsShow () {
      const columns = {}
      columns.program__name = { label: 'Programme' }
      if (this.isAdmin && this.isDistributeur) {
        columns.promoteur__name = { label: 'Promoteur' }
      }
      columns.tax_dispositifs = { label: 'Dispositifs' }
      columns.lot__nature = { label: 'Nature' }
      columns.lot_type = { label: 'Type' }
      columns.profitability = { label: 'Rentabilité' }
      columns.rent = { label: 'Loyer' }
      columns.building = { label: 'Bâtiment' }
      columns.floor = { label: 'Étage' }
      columns.exposures = { label: 'Orientation' }
      return columns
    }
  },
  methods: {
    async deleteFromWishlist () {
      try {
        this.loadDocuments()
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de la suppression du favoris')
      }
    }
  }
}
</script>
